export const FIELD_TYPE = {
  TEXT: 1,
  PARAGRAPH: 2,
  MOBILE_NUMBER: 3,
  EMAIL: 4,
  RADIO: 5,
  CHECKBOX: 6,
  DATE: 7,
  DATETIME: 8,
};